import { Handle, Position } from 'reactflow';
import styles from '../styles/nodes.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglass, faX } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

export default function DelayNode({ id, data }) {
    const { t } = useTranslation();
    const [seconds, setSeconds] = useState(data.value_2 || 5);

    useEffect(() => {
        setSeconds(data.value_2 || 5);
    }, [data]);

    const handleSecondsChange = (event) => {
        let val = parseInt(event.target.value) || 0;
        if (val > 120) val = 120;
        if (val < 0) val = 0;
        setSeconds(val);
        data.value_2 = val;
    };

    const increment = () => {
        const val = Math.min(seconds + 1, 120);
        setSeconds(val);
        data.value_2 = val;
    };

    const decrement = () => {
        const val = Math.max(seconds - 1, 0);
        setSeconds(val);
        data.value_2 = val;
    };

    return (
        <div className={`${styles.scratch_block_delay} shadow`}>
            <Handle type="target" position={Position.Top} id={"i1" + id} style={{ left: '50%' }} />

            <div className="d-flex flex-row w-100 justify-content-between">
                <div className={'d-flex'}>
                    <div className={styles.scratch_block_type_icon_delay}>
                        <FontAwesomeIcon icon={faHourglass} color="white" />
                    </div>
                    <div className={styles.scratch_block_type}>{t('operations.nodes.delay')}</div>
                </div>
                <div className={'px-2 pointer-event'} onClick={() => {
                    if (typeof data.onDeleteNode === 'function') {
                        data.onDeleteNode(id);
                    } else {
                        data.setNodes((prev) => [...prev.filter((node) => node.id !== id)]);
                        data.setDeletionList((prev) => [...prev, id]);
                    }
                }}>
                    <FontAwesomeIcon icon={faX} color={'#999'} size={'sm'} />
                </div>
            </div>

            {data.is_connected_1 ? (
                <div className={styles.scratch_label} style={{ color: '#1E40AF' }}>{data.value_1}</div>
            ) : (
                <div style={{ fontSize: '11px', color: '#3B82F6', fontStyle: 'italic', margin: '8px 0' }}>
                    {t('operations.nodes.connectInputAbove')}
                </div>
            )}

            <div style={{ fontSize: '12px', color: '#1E40AF', margin: '4px 0' }}>
                {t('operations.nodes.waitFor')}
            </div>

            <div className="d-flex align-items-center w-100" style={{ gap: '6px' }}>
                <div className={styles.stepperButton} onClick={decrement}>-</div>
                <input
                    className={styles.scratch_input}
                    type="text"
                    onChange={handleSecondsChange}
                    value={seconds}
                    style={{ width: '50px', textAlign: 'center', padding: '6px' }}
                />
                <div className={styles.stepperButton} onClick={increment}>+</div>
                <span style={{ fontSize: '13px', color: '#1E40AF' }}>{t('operations.nodes.secMax120')}</span>
            </div>

            <div style={{ fontSize: '11px', color: '#1E40AF', marginTop: '8px' }}>
                {t('operations.nodes.thenPassValueBelow')}
            </div>

            <Handle type="source" position={Position.Bottom} id="out" />
        </div>
    );
}
